/* eslint-disable */
import format from 'date-fns/format';
import parse from 'date-fns/parse';

/**
 * Wrapper for date-fns/format when trying to format a date string with format that includes hours/minutes.
 * Otherwise, just use the normal `date-fns/format`
 * @param {string} date The date string
 * @param {string} formatString The format string
 * @param {Object} options The options
 * @returns {Date} The formatted date
 */
const formatWithTime = (date, formatString, options) => {
  // date-fns/format API has an issue with trailing Z which causes a wrong time display.
  // So the date needs to be parsed first.
  const formattedDate = parse(date)
    .toISOString()
    .replace(`Z`, ``);
  return format(formattedDate, formatString, options);
};

export default formatWithTime;
